import React, { Fragment } from 'react';

import EditForm from './_EditForm';
import { FancyDateTime, ChipSelect, TextArea } from '../Forms'

class EditForm_BreastFeed extends EditForm {

  constructor(props, context) {
    super(props, context, 'breast-feed');
  }

  state = {
    start: EditForm.getField('data.start')(this.props.record),
    end: EditForm.getField('data.end')(this.props.record),
    side: EditForm.getField('data.side')(this.props.record),
    notes: EditForm.getField('data.notes')(this.props.record),
  }

  buildRecordData = () => {
    const { start, end, side, notes } = this.state;

    return {
      start: start || null,
      end: end || null,
      side,
      notes,
    };
  }

  renderTopicFields = () => {
    const { start, end, side, notes } = this.state;

    return (
      <Fragment>

        <FancyDateTime
          label="Start"
          margin="normal"
          value={start}
          onChange={this.onChange('start')}
        />

        <FancyDateTime
          label="End"
          margin="normal"
          value={end}
          onChange={this.onChange('end')}
        />

        <ChipSelect
          label="Side"
          margin="normal"
          value={side || ''}
          onChange={this.onChange('side')}
          options={['Left', 'Right']}
        />

        <TextArea
          label="Notes"
          margin="normal"
          rowsMax={8}
          value={notes || ''}
          onChange={this.onDomChange('notes')}
        />
        
      </Fragment>
    );
  }

}
export default EditForm_BreastFeed;
